export const updateCheckbox = (values, selected, isChecked) => {
  const updated = [];
  const sl = new Set(values);
  const shouldAdd = isChecked && !sl.has(selected);
  const shouldRemove = !isChecked && sl.has(selected);

  if (shouldAdd) {
    sl.add(selected);
  } else if (shouldRemove) {
    sl.delete(selected);
  }

  for (let item of sl.values()) updated.push(item);

  return updated;
};

export default updateCheckbox;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/utils/update-checkbox.js